import React from "react";
import styled from "styled-components";

import BackgroundImage from "../../../assets/intro/blur-bg.png";
import AlertIcon from "../../../assets/intro/icon_alert.png";

import typography from "../../../theme/typography";

const Page = styled.div`
  position: relative;
  background-color: #f3ede5;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Background = styled.img`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
`;

const MessageHeader = styled.div`
  position: relative;
  z-index: 100;
  display: flex;
  align-items: center;
  margin-bottom: 3px;
  div {
    ${typography.popupText};
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
`;

const MessageContent = styled.p`
  position: relative;
  z-index: 100;
  ${typography.popupText};
  text-align: left;
  padding: 0 4px;
`;

const Modal = styled.div`
  position: absolute;
  top: 270px;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  padding: 0 20px;
  z-index: 500;
`;

const ModalMessage = styled.div`
  background-color: ${(props) => props.theme.color.white};
  opacity: 0.6;
  border-radius: 10px;
  padding: 2px 8px 14px;
  margin-bottom: 10px;
`;

const SkipButton = styled.button`
  font-size: 20px;
  height: 50px;
  background-color: #ffffff60;
  border: none;
  border-radius: 10px;
  cursor: pointer;
`;

const IntroPage3 = ({ setCurrentPage }) => {
  return (
    <Page>
      <Background
        src={BackgroundImage}
        alt="Reduce Reuse Recycle이 적힌 휴대폰 배경"
      />

      <Modal>
        <ModalMessage>
          <MessageHeader>
            <img src={AlertIcon} alt="경고" />
            <div>
              <span>긴급 안내 문자</span>
              <span>2025년 **월 **일</span>
            </div>
          </MessageHeader>
          <MessageContent>
            긴급 안내 문자
            <br />
            서울시 주민 여러분께 알립니다. 현재 수도권매립지 포화로, 더 이상의
            생활폐기물 매립이 불가능한 상태입니다. 서울시와 환경부가 대안을
            마련하기 위한 방안을 모색 중입니다.
            <br />
            서울시는 1인당 20L의 쓰레기 종량제봉투를 제공 후 수거하고, 그 이상
            발생된 쓰레기는 책임질 수 없습니다. 대체매립지를 찾기 전까지 1인 당
            20L 이상의 쓰레기를 발생하지 않도록 주의해 주십시오. 서울시민
            여러분은 조금만 불편을 참고 각별히 쓰레기 발생에 주의해 주십시오.
          </MessageContent>
        </ModalMessage>
        <SkipButton onClick={() => setCurrentPage(4)}>SKIP</SkipButton>
      </Modal>
    </Page>
  );
};

export default IntroPage3;
